const routes = {
  '/': 'newProposal',
  '/customers': 'customersList',

  '/customers/:id/webhook-events': 'webhookStatusPage',
  '/customers/:id/sponsor-events': 'sponsorEventsStatusPage',

  '/customer/:id/proposal': 'customerRedirectPage',
  '/customers/:id/proposal': 'customerRedirectPage',

  '/customers/:id/signInPerson': 'signInPerson',
  '/customers/:id/signingComplete': 'signingComplete',

  'customers/:id/history': 'customerHistory',

  '/customers/:id/borrowerInfo': 'borrowerInfo',

  '/customers/:id/snapshot': 'snapshot',
  '/customers/:id/ensemble-view': 'ensembleView',

  '/archived-customers': 'archivedCustomersList',
  '/error': 'failWhale',
  '/login': 'login',
  '/reset-password': 'resetPassword',
  '/reset-password/*': 'resetPassword',
  '/sign-up': 'signUp',
  '/proposal/new': 'newProposalExplicit',
  '/proposal/:id': 'proposalRedirect',
  '/proposal/:id/eligibilityPending': 'eligibilityPending',
  '/proposal/:id/financing-method/:financingMethodId/eligibilityStatus': 'eligibilityStatus',
  '/proposal/:id/financing-method/:financingMethodId/customize': 'savingsCalculator',
  '/proposal/:id/financing-method/:financingMethodId/address': 'collectAddressInformation',
  '/proposal/:id/financing-method/:financingMethodId/review': 'reviewCustomerInformation',
  '/proposal/:id/financing-method/:financingMethodId/hand-off': 'handOff',
  '/proposal/:id/financing-method/:financingMethodId/paymentInformation': 'paymentInformation',
  '/proposal/:id/financing-request/:financingRequestId/step-documents': 'stepDocuments',
  '/proposal/:id/financing-request/:financingRequestId/step-documents-external': 'stepDocumentsExternal',
  '/proposal/:id/financing-method/:financingMethodId/stips': 'stips',
  '/proposal/:id/generating-documents': 'generatingDocuments',
  '/proposal/:id/:section': 'proposalSection',
  '/product-not-available': 'productNotAvailable',
  '/training-required': 'trainingRequired',
  '/training-required/*': 'trainingRequired',
  '/no-state-license': 'noStateLicense',
  '/status': 'status',
  '/confirmation': 'confirmation',
  '/quickcheck/:id': 'quickcheck',
  '/quickcheck': 'quickcheck',
  '/proposal/:id/financing-method/:financingMethodId/quickCheckStatus': 'quickCheckStatus',
  '/consent/provide-credit-documents/:token': 'homeownerDocuments',
  '/admin': 'admin',
  '/homeowner/consent/:consentToken': 'homeownerEligibility',
  '/homeowner/consent': 'homeownerEligibilitySubmitted',
  '/admin/financing-request-documents/tier-1': 'frDocumentsTier1List',
  '/admin/financing-request-documents/tier-2': 'frDocumentsTier2List',
  '/admin/financing-request-documents/escalated': 'frDocumentsEscalatedList',
  '/admin/customers/:customerId/document-review': 'frDocumentsDetails',
  '/admin/customers/decisions': 'decisioningTable',
  '/admin/customers/decisions/:id': 'decision',
  '/reports/disbursement': 'disbursement',
  '/download': 'download',
  '/resume': 'resume',
  '/find-products': 'findProducts',
  '/account-details': 'accountDetails',
  '/account-details/mfa': 'mfaPage',
  '/account-details/mfa/*': 'mfaPage',
  '/info/:pageName': 'infoDisplayPage',
  '/cognito-auth.*': 'cognitoAuth',
  '/fake-cognito-auth.*': 'fakeCognitoAuth',
  '/pending-cognito-auth': 'pendingCognitoAuth',
  '/maintenance-page': 'maintenancePage',
  '/quickCheckRemoteCompleted': 'quickCheckRemoteCompleted',
  '/account/users': 'userList',
  '/account/users/:userId': 'editUser',
  '/account/companies': 'companyList',
  '/account/companyInfo': 'companyInfo',
  '/account/company/new': 'companyDetails',
  '/account/branches': 'branchList',
  '/account/branches/new': 'branchDetails',
  '/account/branches/:branchId': 'branchDetails',
  '/account/pricing-branches/:branchId': 'branchDetails',
  '/account/companies/:coid/users': 'userListByCompany',
  '/account/companies/:coid/users/new': 'newUser',
  '/account/companies/:coid/users/:userId': 'editUserByCoid',
  '/account/companies/:coid/pricing': 'pricingGroupList',
  '/account/companies/:coid/pricing-groups/new': 'pricingGroupDetails',
  '/account/companies/:coid/pricing-groups/:pricingId': 'pricingGroupDetails',
  '/account/companies/:coid/signers': 'authorizedSignerList',
  '/account/companies/:coid/signers/new': 'authorizedSignerDetails',
  '/account/companies/:coid/signers/:signerId': 'authorizedSignerDetails',
  '/account/companies/:coid/branches': 'branchList',
  '/account/companies/:coid/branches/new': 'branchDetails',
  '/account/companies/:coid/branches/:branchId': 'branchDetails',
  '/account/companies/:coid/notifications': 'notificationList',
  '/account/companies/:coid/notifications/new': 'notificationDetails',
  '/account/companies/:coid/notifications/:subscriptionId': 'notificationDetails',
  '/account/companies/:coid/licenses': 'licenseList',
  '/account/companies/:coid/licenses/new': 'licenseDetails',
  '/account/companies/:coid/licenses/:licenseId': 'licenseDetails',
  '/account/standby': 'impersonationStandByPage',
  '/account/standby/logout': 'impersonationStandByPage',
  '/account/companies/:coid/companyInfo': 'companyInfoByCompany',
  '/kba-fail': 'kbaFailure',
  '/qa-hidden-v2': 'qaHiddenV2',
  '/disbursements': 'disbursements',

  '/mock-mosaic-esign': 'mockMosaicEsign',

  '/welcome-calls/:guid': 'welcomeCall',
  '/welcome-calls/:guid/complete': 'welcomeCallCompletePage',

  'welcome-calls-error': 'welcomeCallErrorPage',

  'security-center': 'securityCenter',

  '/auto-pay/:token/complete': 'autoPayCompletePage',
  '/auto-pay/:token/preferences': 'autoPayPreferencesPage',

  '/config': 'configRouter',
  '/config/*': 'configRouter',

  ux: 'uxPage',
};

export default routes;
